// apiService.ts
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "./axios";
import { useSelector } from "react-redux";

const getAvailability = async (userId,type) => {
  let query = ''
  if(type){
    query = `?type=${type}`
  }
  console.log(userId,'fetchDataById')
  const response = await axiosInstance.get(
    `/appointments/availability/${userId}${query}`
  );
  return response.data;
};

const getAppointmentData = async (repId) => {
  console.log(repId,'fetchDataById')
  if(repId){
    const response = await axiosInstance.get(
      `/appointments/appointments-list/${repId}`
    );
    return response.data;
  }else{
    return null
  }
};

const saveAvailability = async (data) => {
  const response = await axiosInstance.post(`/appointments/set-availability`, data);
  return response.data;
};

const useAvailability = ({userId = null, repId= null,type=null}={}) => {
  console.log('user id', userId)
  const queryClient = useQueryClient();
  if (!userId) {
    const users = useSelector((state) => state?.userData?.userData?.user);
    console.log(users?._id,'useAvailability')
    userId = users?._id;
  }

  const availability = useQuery({
    queryKey: ["availability",userId,type],
    queryFn: () => getAvailability(userId,type),
    enabled: userId != null,
  });

  const appointmentData = useQuery({
    queryKey: ["appointmentData"],
    queryFn: () => getAppointmentData(repId),
    enabled: !repId,
  });
  const saveAvailabilityMutation  = useMutation({
    mutationFn: saveAvailability,
    onSuccess: (data) => {
    },
    onError: () => {
      // alert('there was an error');
    },
    onSettled: () => {
      // queryClient.invalidateQueries('availability');
      availability.refetch();
    },
  });
  return {
    availability,
    saveAvailabilityMutation,
    appointmentData
  };
};
export default useAvailability;
